import React, { useState } from "react";
import {
  Menu,
  X,
  Zap,
  Info,
  PictureInPicture2Icon,
  Linkedin,
  FacebookIcon,
} from "lucide-react";
import rasLogo from "../assets/company/RAS Logo.png";
import rasLogoOnly from "../assets/company/RAS Logo Only.png";
import { useNavigate } from "react-router-dom";

export default function EventLanding() {
  const navigate = useNavigate();

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const menuItems = [
    // { icon: Calendar, label: "Event Details", id: "event" },
    { icon: Zap, label: "Sponsors & Products", id: "sponsors" },
    { icon: PictureInPicture2Icon, label: "Loo Awards 2025", id: "looawards" },
    { icon: Info, label: "About", id: "about" },
  ];

  return (
    <div className="min-h-screen overflow-hidden">
      {/* Animated background */}
      <div className="fixed inset-0">
        <div className="absolute inset-0 bg-gradient-to-br from-brand-500 via-brand-700 to-cyan-200"></div>
        <div className="absolute top-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>
      </div>

      {/* Navigation */}
      <nav className="backdrop-blur-md bg-white/10 border-b border-white/20 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 relative">
          <div className="flex items-center h-20 justify-between">
            <div className="flex items-center">
              <img
                alt="company logo"
                src={rasLogo}
                className="w-20 h-20 flex items-center justify-center font-bold text-white text-xl"
              />
              {/* <span className="text-white font-bold text-lg hidden sm:inline">
                Event Hub
              </span> */}
            </div>

            {/* Desktop Menu (centered on large screens) */}
            <div className="hidden lg:flex gap-8 absolute left-1/2 transform -translate-x-1/2 z-10">
              {menuItems.map((item) => (
                <button
                  onClick={() => navigate(`/${item.id}`)}
                  key={item.id}
                  className="text-white/80 hover:text-white text-sm font-medium transition-colors flex items-center gap-2 group"
                >
                  <item.icon
                    size={18}
                    className="group-hover:scale-110 transition-transform"
                  />
                  <span>{item.label}</span>
                </button>
              ))}
            </div>

            {/* Mobile Menu Button */}
            <button
              className="lg:hidden text-white p-2"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="lg:hidden pb-4 border-t border-white/20">
              {menuItems.map((item) => (
                <button
                  onClick={() => navigate(`/${item.id}`)}
                  key={item.id}
                  className="w-full text-left text-white/80 hover:text-white py-3 px-4 text-sm font-medium flex items-center gap-3 transition-colors"
                >
                  <item.icon size={18} />
                  <span>{item.label}</span>
                </button>
              ))}
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-32">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="text-5xl lg:text-6xl font-bold text-white drop-shadow-lg">
                Transform{" "}
                <span className="bg-gradient-to-r from-mist-100 to-forest-400 bg-clip-text text-transparent">
                  Your World
                </span>
              </h1>
              <p className="text-xl text-white/90 leading-relaxed">
                Join us for an extraordinary event bringing together industry
                leaders, innovators, and changemakers to drive meaningful
                impact.
              </p>
            </div>

            {/* Feature Cards */}
            <div className="grid grid-cols-2 gap-4">
              {[
                {
                  icon: Linkedin,
                  label: "Follow us on Linkedin",
                  link: "https://www.linkedin.com/company/restroom-association/posts/?feedView=all",
                },
                {
                  icon: FacebookIcon,
                  label: "Follow us on Facebook",
                  link: "https://www.facebook.com/RestroomAssociation/",
                },
              ].map((stat, i) => (
                <a
                  href={stat.link}
                  key={i}
                  className="flex gap-2 items-center backdrop-blur-md bg-white/15 border border-white/30 rounded-2xl hover:bg-white/20 p-4 transition-all duration-300 hover:scale-105"
                >
                  <div className="text-2xl font-bold text-white">
                    <stat.icon
                      size={24}
                      className="group-hover:scale-110 transition-transform"
                    />
                  </div>
                  <div className="text-sm text-white/70">{stat.label}</div>
                </a>
              ))}
              <a
                href="https://www.toilet.org.sg/home"
                key={"ras"}
                className="flex gap-2 items-center backdrop-blur-md bg-white/15 border border-white/30 rounded-2xl hover:bg-white/20 p-4 transition-all duration-300 hover:scale-105"
              >
                <div className="text-2xl font-bold text-white">
                  <img src={rasLogoOnly} alt="RAS Logo" className="w-6" />
                </div>
                <div className="text-sm text-white/70">
                  Discover about our page
                </div>
              </a>
            </div>

            {/* CTA Buttons */}
            {/* <div className="flex gap-4 pt-4">
              <button className="backdrop-blur-md bg-white/25 hover:bg-white/35 border border-white/40 text-white px-8 py-3 rounded-full font-semibold transition-all duration-300 hover:scale-105">
                Register Now
              </button>
              <button className="backdrop-blur-md bg-white/10 hover:bg-white/20 border border-white/30 text-white px-8 py-3 rounded-full font-semibold transition-all duration-300 hover:scale-105">
                Learn More
              </button>
            </div> */}
          </div>

          {/* Glass Cards Stack */}
          <div className="hidden lg:block relative h-96">
            <div className="absolute inset-0 space-y-4">
              {[
                {
                  title: "Our Sponsors & Their Products",
                  path: "sponsors",
                  description:
                    "Explore our trusted sponsors and discover the products that make it all possible!",
                  delay: 40,
                },
                {
                  title: "LOO Awards",
                  path: "about",
                  description:
                    "Discover the mission behind the Loo Award and how we celebrate excellence in restroom design, hygiene, and innovation.",
                  delay: 40,
                },
              ].map((card, i) => (
                <button
                  onClick={() => navigate(`/${card.path}`)}
                  key={i}
                  className="w-full text-left backdrop-blur-xl bg-white/20 border border-white/40 rounded-2xl p-6 hover:bg-white/30 transition-all duration-500 hover:scale-105 cursor-pointer"
                  style={{
                    transform: `rotate(${i * 3}deg) translateY(${i * 20}px)`,
                  }}
                >
                  <h3 className="text-white font-bold text-lg">{card.title}</h3>
                  <p className="text-white/70 text-sm mt-2">
                    {card.description}
                  </p>
                </button>
              ))}
              <a
                href="https://www.giving.sg/organisation/profile/d11d7604-261a-4581-980b-0b12b75550b0"
                className="w-full block text-left backdrop-blur-xl bg-white/20 border border-white/40 rounded-2xl p-6 hover:bg-white/30 transition-all duration-500 hover:scale-105 cursor-pointer"
                style={{
                  transform: `rotate(${2 * 3}deg) translateY(${2 * 20}px)`,
                }}
              >
                <h3 className="text-white font-bold text-lg">
                  Donate towards the Cause
                </h3>
                <p className="text-white/70 text-sm mt-2">
                  Make a difference! Contribute to our mission and support
                  better restroom standards.
                </p>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="relative backdrop-blur-md bg-white/10 border-t border-white/20 mt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid md:grid-cols-2 gap-8 mb-8">
            <div>
              <h4 className="text-white font-bold mb-4">About RAS</h4>
              <p className="text-white/70 text-sm">
                Building positive change through community engagement.
              </p>
            </div>
            <div>
              <h4 className="text-white font-bold mb-4">Follow Us</h4>
              <div className="flex gap-3 text-white/70 text-sm">
                {[
                  {
                    key: "linkedin",
                    path: "https://www.linkedin.com/company/restroom-association/posts/?feedView=all",
                    icon: Linkedin,
                  },
                  {
                    key: "facebook",
                    path: "https://www.facebook.com/RestroomAssociation/",
                    icon: FacebookIcon,
                  },
                ].map((stat, i) => (
                  <a href={stat.link} key={stat.key}>
                    <stat.icon
                      size={20}
                      className="hover:text-white transition-colors cursor-pointer"
                    />
                  </a>
                ))}
                <a href="https://www.toilet.org.sg/home" key="rasFooter">
                  <img
                    src={rasLogoOnly}
                    alt="RAS Logo"
                    className="w-5 hover:text-white transition-colors"
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="border-t border-white/20 pt-8 text-center text-white/60 text-sm">
            <p>&copy; 2025 RAS Event. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
